import { Base64 } from 'js-base64';
import { LogOption } from './log.d';

/* eslint-disable no-param-reassign */
const uploadLog = (log: LogOption) => {
  const img = new Image();
  log.browserName = navigator.appName;
  log.browerUA = navigator.userAgent;
  log.browserVersion = navigator.appVersion;
  log.browserCodeName = navigator.appCodeName;
  log.page = window.location.href;
  log.time = Date.now();
  /* eslint-disable prefer-template */
  img.src = process.env.VUE_APP_LOG_HOST + '/log.gif?'
    + Base64.encode(JSON.stringify(log));
};

const info = (log: LogOption) => {
  // log.type = 'info';
  // uploadLog(log);
};

const error = (log: LogOption) => {
  // log.type = 'error';
  // uploadLog(log);
};

export const operate = (log: LogOption) => {
  // log.type = 'operate';
  // uploadLog(log);
};

export const vueError = (log: LogOption) => {
  // log.type = 'vueError';
  // uploadLog(log);
};

export default {
  info,
  error,
  operate,
  vueError,
};
